<template>
    <div>
        <b-form-group label="Bundle Suggested Price" label-for="suggestedPrice">
            <b-input-group prepend="$">
                <input
                    class="form-control"
                    type="text"
                    :value="formattedSuggestedPrice"
                    readonly
                />
            </b-input-group>
            <div v-if="error" class="mt-2">
                <small class="text-danger">{{ error }}</small>
            </div>
        </b-form-group>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'PromoBundleSuggestedPrice',
    props: {
        assetId: {
            type: [Number, String],
            required: true,
        },
        initialStartDate: {
            type: String,
            default: '',
        },
        initialEndDate: {
            type: String,
            default: '',
        },
        initialBundleAssets: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            startDate: this.initialStartDate,
            endDate: this.initialEndDate,
            bundleAssets: [...this.initialBundleAssets],
            suggestedPrice: 0,
            isLoading: false,
            error: null,
        };
    },
    computed: {
        formattedSuggestedPrice() {
            return this.suggestedPrice.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        },
    },
    mounted() {
        // Listen for updates from other components - using the same event name as the original Livewire component
        Bus.$on('updatePromoSuggestedPrice', this.updateBundleAssets);

        // Calculate initial price if we have the required data
        if (this.startDate && this.endDate && this.bundleAssets.length > 0) {
            this.calculateSuggestedPrice();
        }
    },
    beforeDestroy() {
        Bus.$off('updatePromoSuggestedPrice', this.updateBundleAssets);
    },
    methods: {
        updateBundleAssets(payload) {
            console.log(payload);
            // Debug logging to see what's being passed

            this.endDate = payload.dates?.end_date || this.endDate;
            this.startDate = payload.dates?.start_date || this.startDate;
            this.bundleAssets = payload.assets || this.bundleAssets;

            console.log('After update - start:', this.startDate, 'end:', this.endDate);

            // Recalculate the suggested price
            this.calculateSuggestedPrice();
        },
        async calculateSuggestedPrice() {
            if (!this.startDate || !this.endDate || this.bundleAssets.length === 0) {
                this.suggestedPrice = 0;
                return;
            }

            this.isLoading = true;
            this.error = null;

            const payload = {
                start_date: this.startDate,
                end_date: this.endDate,
                bundle_assets: this.bundleAssets,
            };

            try {
                const response = await axios.post(`/api/team/assets/${this.assetId}/suggested-price`, payload);

                this.suggestedPrice = response.data.suggested_price || 0;
            } catch (error) {
                console.error('Error calculating suggested price:', error);
                this.error = 'Unable to calculate suggested price';
                this.suggestedPrice = 0;
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>
</template>

<style scoped>
/* Add any component-specific styles if needed */
</style>
